import 'css-chunk:src/app/containers/Home/ReportingView/ReportingDetailView.scss';export default {
  "tableauContainer": "_tableauContainer_gztbe_1"
};